export const CLEAR_ERROR_AND_ISLOADING = 'CLEAR_ERROR_AND_ISLOADING';
export const CLEAR_ALL_ERROR_AND_ISLOADING = 'CLEAR_ALL_ERROR_AND_ISLOADING';

export const FETCH_AVAILABLE_YEARS_REQUEST = 'FETCH_AVAILABLE_YEARS_REQUEST';
export const FETCH_AVAILABLE_YEARS_SUCCESS = 'FETCH_AVAILABLE_YEARS_SUCCESS';
export const FETCH_AVAILABLE_YEARS_FAILURE = 'FETCH_AVAILABLE_YEARS_FAILURE';

export const FETCH_INFO_REQUEST = 'FETCH_INFO_REQUEST';
export const FETCH_INFO_SUCCESS = 'FETCH_INFO_SUCCESS';
export const FETCH_INFO_FAILURE = 'FETCH_INFO_FAILURE';
